import type { KeycloakResponse } from '../types/KeycloakResponse'

export class KcError extends Error {
  endpoint: string
  status?: string
  message: string
  location?: string

  constructor(kcResponse: KeycloakResponse, endpoint: string) {
    super()
    this.endpoint = endpoint
    this.status = kcResponse.status
    this.message = kcResponse.message
    this.location = kcResponse.location
  }
}
